<template>
    <div>
        <div class="cb">
            <span class="line fl"></span>
            <span class="fl dc">修改密码</span>
        </div>
        <div class="title">选择验证方式</div>
        <div class="r-main">
            <div class="list">
                <div class="list-left">
                    <div class="left-icon">
                        <i class="icon-phone"></i>
                    </div>

                    <div class="left-tip">
                        <span class="left-title">通过手机验证</span>
                        <span>如果你的绑定手机可用，则可通过绑定的手机发送验证码修改</span>
                    </div>
                </div>
                <router-link to="/users/psw/modify-phone" class="button bg">立即验证</router-link>
            </div>
            <div class="list">
                <div class="list-left">
                    <div class="left-icon">
                        <i class="icon-password"></i>
                    </div>

                    <div class="left-tip">
                        <span class="left-title">通过密码验证</span>
                        <span>如果你的原密码可用，则可通过原密码修改</span>
                    </div>
                </div>
                <router-link to="/users/psw/modify-psw" class="button bg">立即验证</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SelectMode"
    }
</script>

<style scoped>
    @import "../../../static/css/views/user/select-mode.css";
</style>


// WEBPACK FOOTER //
// src/views/user/SelectMode.vue